<template>
  <div class="page">
    <div class="t1">关注微信公众号</div>
    <div class="t2">更多生命灵粮与您共享</div>
    <div class="t0" v-if="tip">当前集数已播放完毕，邀请您关注公众号</div>
    <div class="t01" v-else>下一步</div>
    <div class="qrcode">
      <img :src="qrcode">
    </div>
    <div class="t3">关注指南:</div>
    <div class="t4">长按识别关注后，请重新进入</div>
    <div class="btn" v-if="ignore">
      <a class="off" href="javascript:;" @click="onCancel">下次再说</a>
    </div>
    <div class="t5">
      邀请弟兄姊妹关注微信公众号，每日丰富灵粮
      <br>精彩呈现，维护通知同步获取。
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      qrcode: '',
      ignore: false
    }
  },
  computed: {
    tip() {
      return this.$route.query.tip
    }
  },
  mounted() {
    this.$service.user.isSettingReady(this.onReady)
  },
  methods: {
    onReady() {
      this.qrcode = this.$service.user.setting.h5_force_qrcode
      this.ignore = this.$service.user.setting.h5_subscribe_ignore
    },
    onCancel() {
      this.$service.user.goReturn(this, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding-top: 40px;
  text-align: center;
}
.qrcode {
  margin-bottom: 10px;
  img {
    width: 150px;
    height: 150px;
    box-shadow: 0 1px 10px #cccccc;
  }
}
.t0 {
  color: $color-red;
  line-height: 30px;
  margin-bottom: 20px;
}
.t01 {
  color: $color-red;
  font-size: 18px;
}
.t1 {
  font-size: 18px;
  color: #48b1e3;
}
.t2 {
  font-size: 12px;
  color: #a9a9a9;
  margin-bottom: 50px;
}
.t3 {
  font-size: 16px;
  color: #48b1e3;
}
.t4 {
  font-size: 12px;
  color: #404040;
}
.t5 {
  font-size: 12px;
  color: #404040;
  margin-top: 60px;
}
.btn {
  margin-top: 30px;
  a {
    display: inline-block;
    width: 300px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: white;
    border-radius: 100px;
    background-color: #48b1e3;
  }
}
</style>



// WEBPACK FOOTER //
// root.vue?1d459506